import { IntegrationDetailsInlineEditor } from 'pages/Settings/Integrations/tabs/IntegrationDetailsInlineEditor';
import {
    AuthenticationType,
    IntegrationDetails,
} from 'pages/Settings/Integrations/types';

export type AuthenticationDetailsContentProps = Readonly<{
    data: IntegrationDetails;
    onConfirm: (value: Partial<IntegrationDetails>) => void;
    isDisabled?: boolean;
}>;

export function AuthenticationDetailsContent({
    data,
    onConfirm,
    isDisabled = false,
}: AuthenticationDetailsContentProps) {
    const isBasic = data.authtype === AuthenticationType.Basic;

    if (!data.authtype) {
        return null;
    }

    return (
        <>
            {data.authtype !== AuthenticationType.ApiKey && (
                <IntegrationDetailsInlineEditor
                    name={isBasic ? 'UserID' : 'Client'}
                    value={data.id}
                    isDisabled={isDisabled}
                    onConfirm={(value) => onConfirm({ id: value })}
                    type="secret"
                />
            )}
            <IntegrationDetailsInlineEditor
                name={isBasic ? 'Password' : 'Secret'}
                value={data.secret}
                isDisabled={isDisabled}
                onConfirm={(value) => onConfirm({ secret: value })}
                type="secret"
                canClear={false}
            />
            {data.authtype === AuthenticationType.OAuth && (
                <IntegrationDetailsInlineEditor
                    name="Token URL"
                    value={data.tokenurl}
                    isDisabled={isDisabled}
                    onConfirm={(value) => onConfirm({ tokenurl: value })}
                    type="url"
                />
            )}
        </>
    );
}
